import React, { Component } from 'react';
import PopUpReport from './_Report';
import '../../_css/Report.css';
import Dateconvert from '../../CustomFunction/Date/Dateconvert'
import CustomDateRangePicker from '../../Components/CustomDatepicker/DateRangePicker'
import getDate from './../../CustomFunction/Getdate'
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { GetCorServicei } from '../../_getjson';
import { MenuItem } from 'react-bootstrap';
export default class App extends Component {
    state = {
        reportID: "PD001",
        Parameter: {},
    }

    componentDidMount() {
        this.textInput = React.createRef();

    }

    selectChange = (e) => {
        var reportID = e.target.value;
        this.setState({ reportID: reportID });

    }

    SelectSetData = (type, data) => {
        switch (type) {
            case "brandname": this.refs.p_brandname.value = data; break;
            default: break;
        }
    }
    onShowReport = (e) => {
        var dataP = {
            p_datein: typeof this.state.statestartdate === "undefined" ? getDate() : Dateconvert(this.state.statestartdate)
            // p_dateto : ReDate(this.refs.p_dateto.value),
            // p_type : this.refs.p_type.value,
            // p_brandname : this.refs.p_brandname.value,
            // p_model : this.refs.p_model.value,
            // p_color : this.refs.p_color.value,
            , p_status: typeof this.state.status === "undefined" ? "" : this.state.status
        }
        this.setState({ Parameter: dataP });
        setTimeout(() => {
            this.switchReport(); // เปิดรายงานขึ้นมา
        }, 200);
    }
    switchReport = () => {
        this.setState({ showReports: !this.state.showReports, tfdocPrint: "" });
    }
    daters(e) {

        this.setState({ statestartdate: e })
    }

    _handleSearch = query => {
        this.setState({ isLoading: true });
        var _url = "";
        var _code = "";
        var _name = "";

        console.log("sssss", this.state.chkfocus)
        switch (this.state.chkfocus) {

            // case "dimension":
            //     _url = "CSDIMENSION1/getdata?";
            //     _code = "CODE";
            //     _name = "MYNAMETH";
            //     break;

            // case "brandname":
            //     _url = "CSPDSUBGROUP2/getAll?top=500";
            //     _code = "CODE";
            //     _name = "MYNAMETH";
            //     break;
            case "status":
                _url = "CSPDSUBGROUP3/getAll?top=500";
                _code = "CODE";
                _name = "MYNAMETH";
                break;
            // case "model":
            //     _url = "CSPDSUBGROUP4/getAll?top=500";
            //     _code = "CODE";
            //     _name = "MYNAMETH";
            //     break;

            // case "color":
            //     _url = "CSPDSUBGROUP5/getAll?top=1000";
            //     _code = "CODE";
            //     _name = "MYNAMETH";
            //     break;
        }

        return GetCorServicei(_url, "").then(res => {
            console.log(res);
            if (res !== "error") {
                var element = [];
                for (let index = 0; index < res.data.length; index++) {
                    element.push(res.data[index][_code] + " | " + res.data[index][_name]);
                }
                console.log(element);
                this.setState({
                    isLoading: false,
                    options: element
                });
            }
            setTimeout(() => {
                console.log(this.state.options);
            }, 300);
            return "SS";
        });
    }

    _blurinput = () => {
        //  console.log("xxxx" + this.input.value);
        var _txtselect = "";
        var _code = "";
        switch (this.state.chkfocus) {
            case "dimension":
                _txtselect = "" + this.state.selecteddimension;
                _code = _txtselect.split("|");
                this.setState({ dimension: _code[0].trim() });
                // setTimeout(() => {
                //      console.log("_nametxt" + this.state.dimension);
                // }, 100);
                break;
            case "brandname":
                _txtselect = "" + this.state.selectedbrandname;
                _code = _txtselect.split("|");
                this.setState({ brandname: _code[0].trim() });
                // setTimeout(() => {
                //      console.log("_nametxt" + this.state.brandname);
                // }, 100);
                break;
            case "model":
                _txtselect = "" + this.state.selectedmodel;
                _code = _txtselect.split("|");
                this.setState({ model: _code[0].trim() });
                // setTimeout(() => {
                //      console.log("_nametxt" + this.state.dimension);
                // }, 100);
                break;

            case "color":
                _txtselect = "" + this.state.selectedcolor;
                _code = _txtselect.split("|");
                this.setState({ color: _code[0].trim() });
                break;

            case "status":
                _txtselect = "" + this.state.selectedstatus;
                _code = _txtselect.split("|");
                this.setState({ status: _code[0].trim() });
                break;
        }
        // setTimeout(() => {
        //     console.log("dimension" + this.state.dimension);
        // }, 100);
    };


    render() {
        return (
            <div className="report">
                {this.state.showReports ? <PopUpReport close={this.switchReport} reportID={this.state.reportID} Parameter={this.state.Parameter} /> : null}
                <nav class="navbar TopApp sticky">
                    <div class="flex-list">
                        <ul class="nav navbar-nav navbar-left">
                        </ul>
                        <ul class="nav navbar-nav navbar-right" style={{ 'margin-right': '0px' }}>
                            <li>รายงานสินค้าคงคลัง</li>
                            <span className="pipe"></span>
                        </ul>
                    </div>
                </nav>
                <div class="maindiv col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <select onChange={this.selectChange.bind(null)} size="20">
                        <option value="PD001"> PD001-รายงาน PDI HONDA </option>
                        <option value="PD002"> PD002-รายงาน PDI HONDA(มดแดง) </option>
                        {/* <option value="TB002"> TB002-รายงานสติ๊กเกอร์-ซื้อ </option>
                    <option value="TB003"> TB003-รายงานสติ๊กเกอร์-สต๊อกคงเหลือ </option> */}
                    </select>
                </div>
                <div class="maindiv col-xs-12 col-sm-6 col-md-6 col-lg-6"></div>
                <div class="maindiv col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div class='input-group col-xs-12 col-sm-12 col-md-12 col-lg-12'  >
                        <CustomDateRangePicker titleStart={"วันที่ที่ต้องการ"} titleEnd={"ถึงวันที่"} dateEndEnable={false} startDate={e => this.daters(e)} />
                    </div>
                    <div class='input-group col-xs-12 col-sm-12 col-md-12 col-lg-12'  >
                        <AsyncTypeahead
                            {...this.state}
                            labelKey="status"
                            onChange={(selectedstatus) => this.setState({ selectedstatus })}
                            onBlur={this._blurinput}
                            onSearch={this._handleSearch}
                            minLength={1}
                            placeholder="สถานะ..."
                            renderMenuItemChildren={(option, props) => (
                                <MenuItem key={option} > {option} </MenuItem>
                            )}
                            onFocus={() => this.setState({ chkfocus: "status" })}
                        />
                    </div>
                </div>
                <input type="button" onClick={this.onShowReport} value="เรียกดู" />
            </div>
        );
    }
}

